module.exports = __webpack_public_path__ + "img/up.d058a974.svg";